import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CheckInDetailsState = {
  vehicleNumber?: string;
  pilotName?: string;
  timeSinceAllocated?: string;
  odometer?: number;
  soc?: number;
  dailyRun?: string;
  lastChargingSessions?: string;
  canValidityScore?: string;
  efficiencyScore?: string;
  token?: string;
  et_id?: string;
};

const initialState: CheckInDetailsState = {};

const checkInDetailsSlice = createSlice({
  name: "checkInDetails",
  initialState,
  reducers: {
    setCheckInDetails: (state, action: PayloadAction<CheckInDetailsState>) => {
      return action.payload;
    },
  },
});

export const { setCheckInDetails } = checkInDetailsSlice.actions;
export default checkInDetailsSlice.reducer;
